import React from 'react'
import { useTranslation } from 'react-i18next'
import './style.css'

export default function ChangeDetails({ record }) {
  const { t } = useTranslation();

  const renderFieldValue = (value) => {
    if (value === null || value === undefined) return 'null';
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        return value.length > 0 ? JSON.stringify(value, null, 2) : '[]';
      }
      return JSON.stringify(value, null, 2);
    }
    return String(value);
  };

  const flattenObject = (obj, prefix = '') => {
    const flattened = {};

    for (const [key, value] of Object.entries(obj)) {
      const newKey = prefix ? `${prefix}.${key}` : key;

      if (key === 'content' && value && typeof value === 'object' && !Array.isArray(value)) {
        // Flatten the content object
        Object.assign(flattened, flattenObject(value, ''));
      } else {
        flattened[newKey] = value;
      }
    }

    return flattened;
  };
  return (
    <div className="expanded-content">
      {record.action === 'UPDATE' && record.changes && (
        <div>
          {/* <h4 className="section-title">
            Changed Fields ({record.changes.length})
          </h4> */}
          <div className="fields-container">
            {record.changes?.map((change) => (
              <div key={change.id} className="field-card">
                <div className="field-header">
                  <span className="field-name">
                    {change.field}
                  </span>
                </div>
                <div className="field-comparison">
                  <div>
                    <div className="field-label">{t('activity.previousValue')}</div>
                    <div className="field-value field-value-old">
                      <pre className="field-pre field-pre-old">
                        {renderFieldValue(change.old_value)}
                      </pre>
                    </div>
                  </div>
                  <div>
                    <div className="field-label">{t('activity.newValue')}</div>
                    <div className="field-value field-value-new">
                      <pre className="field-pre field-pre-new">
                        {renderFieldValue(change.new_value)}
                      </pre>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {record.action === 'DELETE' && record.oldData && (
        <div>
          {/* <h4 className="section-title">
            Details
          </h4> */}
          <div className="fields-container">
            {Object.entries(flattenObject(record.oldData)).map(([field, value]) => (
              <div key={field} className="field-card">
                <div className="field-header">
                  <span className="field-name">
                    {field}
                  </span>
                </div>
                <div>
                  {/* <div className="field-label">Deleted Value</div> */}
                  <div className="field-value field-value-old">
                    <pre className="field-pre field-pre-old">
                      {renderFieldValue(value)}
                    </pre>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {record.action === 'INSERT' && record.newData && (
        <div>
          {/* <h4 className="section-title">
            Created Fields ({Object.keys(flattenObject(record.newData)).length})
          </h4> */}
          <div className="fields-container">
            {Object.entries(flattenObject(record.newData)).map(([field, value]) => (
              <div key={field} className="field-card">
                <div className="field-header">
                  <span className="field-name">
                    {field}
                  </span>
                </div>
                <div>
                  <div className="field-label">{t('activity.createdValue')}</div>
                  <div className="field-value field-value-new">
                    <pre className="field-pre field-pre-new">
                      {renderFieldValue(value)}
                    </pre>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
